import {
  ORDER_STATUS_LABELS,
} from "./orderConstants";


export const formatNumber = (
  value
) => {
  return new Intl.NumberFormat(
    "en-IN"
  ).format(
    Number(value || 0)
  );
};


export const formatCurrency = (
  value
) => {
  return new Intl.NumberFormat(
    "en-IN",
    {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }
  ).format(
    Number(value || 0)
  );
};


export const formatDate = (
  value
) => {
  if (!value) {
    return "-";
  }

  const date =
    new Date(value);

  if (
    Number.isNaN(
      date.getTime()
    )
  ) {
    return "-";
  }

  return new Intl.DateTimeFormat(
    "en-IN",
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }
  ).format(date);
};


export const getStatusClass = (
  status
) => {
  return String(
    status || ""
  )
    .trim()
    .toLowerCase()
    .replace(
      /_/g,
      "-"
    );
};


export const getOrderStatusLabel = (
  status
) => {
  return (
    ORDER_STATUS_LABELS[
      status
    ] ||
    String(
      status || "-"
    ).replace(
      /_/g,
      " "
    )
  );
};


export const getOrderItemCount = (
  order
) => {
  if (
    !Array.isArray(
      order?.products
    )
  ) {
    return 0;
  }

  return order.products.reduce(
    (
      total,
      item
    ) => {
      return (
        total +
        Number(
          item?.qty ||
          0
        )
      );
    },
    0
  );
};


export const canCancelOrder = (
  order
) => {
  return ![
    "shipped",
    "out_for_delivery",
    "delivered",
    "cancelled",
    "returned",
  ].includes(
    order?.status
  );
};


export const canReturnOrder = (
  order
) => {
  return (
    order?.status ===
    "delivered"
  );
};


export const getPrimaryOrderAction = (
  order
) => {
  switch (
    order?.status
  ) {
    case "pending":
      return {
        action:
          "accept",

        label:
          "Accept Order",
      };

    case "confirmed":
      return {
        action:
          "processing",

        label:
          "Start Processing",
      };

    case "processing":
      return {
        action:
          "packed",

        label:
          "Mark Packed",
      };

    case "packed":
      return {
        action:
          "ship",

        label:
          "Ship Order",
      };

    case "shipped":
      return {
        action:
          "out_for_delivery",

        label:
          "Out for Delivery",
      };

    case "out_for_delivery":
      return {
        action:
          "delivered",

        label:
          "Mark Delivered",
      };

    default:
      return null;
  }
};